import {create} from 'zustand';
import {devtools} from 'zustand/middleware';

export interface SavedAccountsContext {
  accountName?: string;
  action: 'save' | 'editTag' | 'addTag' | 'removeTag';
  notificationType: 'modal' | 'toast';
  numAccounts: number;
  numUpdatedTags?: number;
}

interface SavedAccountsStore {
  savedAccountsContext: SavedAccountsContext | null;
  setSavedAccountsContext: (context: SavedAccountsContext | null) => void;
}

export const useSavedAccountsStore = create<SavedAccountsStore>()(
  devtools<SavedAccountsStore>((set) => ({
    savedAccountsContext: null,
    setSavedAccountsContext: (context) => set({savedAccountsContext: context}),
  }))
);
